import React, { useEffect, useRef, useState } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import Styles from './custom-bootstrap-table.scss';
import Skeleton from 'react-loading-skeleton';
import SortCaret from './sort-caret';
import { Col, Row } from 'react-bootstrap';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import IconButton from '../icon-button/icon-button';
import CustomBootstrapTableMobile from './custom-bootstrap-table-mobile';
const CustomBootstrapTable = ({ keyField, data, columns, optionsPaginationFactory: overwriteOptionsPaginationFactory, disablePagination = false, loading = false }) => {
    const portalRenderPaginationTotal = useRef();
    const [portalReady, setPortalReady] = useState(false);
    useEffect(() => {
        if (portalRenderPaginationTotal.current)
            setPortalReady(true);
    }, [portalRenderPaginationTotal.current]);
    const renderDropDown = ({ options, currSizePerPage, onSizePerPageChange }) => {
        return (React.createElement(Row, { className: Styles.borderBottomTable },
            React.createElement(Col, { md: 4, className: Styles.customSelectWrap },
                "Show",
                React.createElement("select", { onChange: e => onSizePerPageChange(e.target.value) },
                    React.createElement("option", { value: 5 }, "5"),
                    React.createElement("option", { value: 10 }, "10"),
                    React.createElement("option", { value: 15 }, "15"),
                    React.createElement("option", { value: 20 }, "20"),
                    React.createElement("option", { value: data.length }, "All")),
                React.createElement("span", { style: { paddingLeft: 5 } }, "entries"))));
    };
    const renderPageList = (options) => {
        // console.log(options);
        return (React.createElement(Col, { md: 6, className: classNames('react-bootstrap-table-pagination-list', Styles.paginationWrap, Styles.borderBottomTable) },
            React.createElement("span", { ref: portalRenderPaginationTotal }),
            React.createElement(IconButton, { onClick: () => options.onPageChange(`<`), className: Styles.leftBtn },
                React.createElement("svg", { width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                    React.createElement("path", { d: "M7.70492 1.41L6.29492 0L0.294922 6L6.29492 12L7.70492 10.59L3.12492 6L7.70492 1.41Z", fill: "#BBBBBB" }))),
            React.createElement(IconButton, { onClick: () => options.onPageChange(`>`), className: Styles.rightBtn },
                React.createElement("svg", { width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                    React.createElement("path", { d: "M1.70492 0L0.294922 1.41L4.87492 6L0.294922 10.59L1.70492 12L7.70492 6L1.70492 0Z", fill: "#BBBBBB" })))));
    };
    const renderPaginationTotal = (start, to, total) => {
        return portalReady
            ? ReactDOM.createPortal(React.createElement("span", { className: Styles.paginationTotal },
                React.createElement("span", { className: Styles.start }, start),
                React.createElement("span", null, "-"),
                React.createElement("span", { className: Styles.to }, to),
                React.createElement("span", { className: Styles.separator }, "/"),
                React.createElement("span", { className: Styles.total }, total)), portalRenderPaginationTotal.current)
            : null;
    };
    const optionsPaginationFactory = {
        sizePerPage: 5,
        // firstPageText: "First",
        // lastPageText: "Last",
        alwaysShowAllBtns: true,
        showTotal: true,
        pageListRenderer: renderPageList,
        paginationTotalRenderer: renderPaginationTotal,
        sizePerPageRenderer: renderDropDown
        // sizePerPageOptionRenderer: this.renderDropDown
    };
    const pagination = disablePagination
        ? undefined
        : paginationFactory(Object.assign(Object.assign({}, optionsPaginationFactory), overwriteOptionsPaginationFactory));
    return (React.createElement(BootstrapTable, { bootstrap4: true, bodyClasses: Styles.bodyClasses, bordered: false, keyField: keyField, data: loading ? [] : data, columns: columns.map(i => (Object.assign(Object.assign({}, i), { sortCaret: SortCaret }))), pagination: pagination, noDataIndication: () => React.createElement(NoDataIndication, { loading: loading }), headerClasses: Styles.headerClasses, rowClasses: Styles.rowClasses }));
};
const NoDataIndication = ({ loading }) => {
    if (loading)
        return React.createElement(Skeleton, { count: 5, height: 20 });
    return React.createElement("div", { className: Styles.emptyTable }, "No records");
};
const WitchCustomBootstrapTable = props => {
    if (props.showMobile) {
        return React.createElement(CustomBootstrapTableMobile, Object.assign({}, props));
    }
    return React.createElement(CustomBootstrapTable, Object.assign({}, props));
};
export default WitchCustomBootstrapTable;
